export default __webpack_public_path__ + "static/media/bed2.68a2bf1b.jpg";